import { getters } from '@/modules/core/app/helpers/store';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { AppModule } from '@/modules/core/app/constants/app.constants';

export class GlobalFilterRouteConfig extends PageRouteConfig {
  /**
   * Any contextual permissions based on route
   * @returns {boolean}
   */
  canAccessRouteFromContext() {
    const userSettings = getters.session.getUserSettings();
    return (
      userSettings.isSuperAdmin() && userSettings.isModuleAvailable(AppModule.CUSTOM_GLOBAL_FILTER)
    );
  }
}
